import { cn } from "@/lib/utils";
import { forwardRef } from "react";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, placeholder, required, ...props }, ref) => {
    return (
      <div className="w-full relative">
        <textarea
          className={cn(
            "w-full resize-none text-sm py-3 outline-none placeholder:text-[#E5E5E5] disabled:bg-transparent disabled:text-[#E5E5E5] rounded border-b border-[#F0F0F0] hover:border-[#FF5100] focus:border-[#FF5100] md:border md:border-[#C2C6CE] md:px-4",
            className
          )}
          ref={ref}
          {...props}
        />
        {placeholder && !props.value && (
          <span
            className={cn(
              "pointer-events-none absolute left-0.5 top-3 z-10 text-sm text-[#A6A6A6] after:pl-0.5 after:text-[#FF5100] md:text-[#E5E5E5] md:left-4",
              required ? "after:content-['*']" : ""
            )}>
            {placeholder}
          </span>
        )}
      </div>
    );
  }
);
Textarea.displayName = "Textarea";

export default Textarea;
